import Decimal from "decimal.js";

export class ConversaoApresentacaoEntrada {
  static atualizeQuantidadeBase(item: any): string | null {
    if(!item || !item.apresentacaoCompraInsumo){
      delete item.quantidadeApresentacao;
      return null;
    }

    try {
      const quantidade = new Decimal(item.quantidadeApresentacao);
      const fator = new Decimal(item.apresentacaoCompraInsumo.apresentacaoCompra.fatorConversao);
      if(!quantidade.isFinite() || quantidade.lessThanOrEqualTo(0))
        throw new Error("Informe uma quantidade de unidades de compra maior que zero.");
      if(quantidade.decimalPlaces() > 6)
        throw new Error("A quantidade de unidades de compra aceita no máximo 6 casas decimais.");
      const quantidadeBase = quantidade.mul(fator);
      if(quantidadeBase.decimalPlaces() > 3)
        throw new Error("A conversão resulta em mais de 3 casas decimais na unidade-base.");
      if(quantidadeBase.greaterThan("999999.999"))
        throw new Error("A quantidade convertida ultrapassa o limite do estoque.");
      item.quantidade = quantidadeBase.toNumber();
      return null;
    } catch (erro) {
      delete item.quantidade;
      return erro && erro.message ? erro.message : "Conversão da unidade de compra inválida.";
    }
  }
}
